import {override} from "mobx";
import {LanguageMenuModuleMenuModel} from "./language-menu-module.menu.model";
import styles from "../../styles/language-menu.module.scss";
import type {LanguageViewModel} from "../../../../domain/locale/models/language/language.view-model";
import {LANGUAGE_MENU} from "../../language-menu-module.consts";
import {SCREEN_RESOLUTION} from "../../../../core/consts";

export class LanguageMenuModuleMenuExpandModel extends LanguageMenuModuleMenuModel {
  @override get logoSize(): Number {
    return 24;
  }

  @override get className(): String {
    return styles.expand;
  }

  @override get headerName(): String {
    return this.selectedLanguage.name;
  }

  @override get shouldRenderButtonLabel(): Boolean {
    return true
  }

  @override get shouldArrowOpenMenu(): Boolean {
    return false;
  }

  @override get showSelectedLanguageLabel(): Boolean {
    return true;
  }

  @override get shouldRenderHeaderFullDisplay(): Boolean {
    return this.isMenuOpen;
  }

  @override get shouldCollapsedOnBgClick(): Boolean {
    return false;
  }

  @override get items(): Array<LanguageViewModel> {
    const items = this.languages.filter(lang => lang.id !== this.selectedLanguage.id);
    items.unshift(this.selectedLanguage)

    return items
  }

  @override get headerItems(): Array<LanguageViewModel> {
    return this.items
  }

  @override get collapsedItems(): Array<LanguageViewModel> {
    return null
  }

  @override get numOfHeaderItemsDisplay(): Number {
    return this.screenWidth < SCREEN_RESOLUTION.xl_min ? LANGUAGE_MENU.EXPAND_DISPLAY_ITEMS.mobile : LANGUAGE_MENU.EXPAND_DISPLAY_ITEMS.desktop
  }
}